import "./user.service";
export const userResolver = ["User", (user) => user.setupDto()];
